import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Dialog from '~/components/Dialog'
import { RouteTypes } from '~/routes/constants'
import { SelectedContent, SelectedWrapper } from '../style'
import { Icon, Input } from 'semantic-ui-react'

interface Props {
  isDialogOpen: boolean
  handleClose: () => void
  farmers: any[]
  remove: (index: number) => void
}

const ShowMoreDialog:React.FC<Props> = (props) => {
  const { t } = useTranslation()
  const { isDialogOpen, handleClose, remove } = props

  const [farmers, setFarmers] = useState(props.farmers)
  const [search, setSearch] = useState('')

  useEffect(() => {
    if(isDialogOpen) {
      setFarmers(props.farmers)
    } else {
      setFarmers([])
    }
  }, [isDialogOpen, props.farmers])

  useEffect(() => {
    if(search !== '') {
      const newFarmers = props.farmers.filter(farmer => farmer?.companyName?.toLowerCase()?.includes(search.toLowerCase()))
      setFarmers(newFarmers)
    } else {
      setFarmers(props.farmers)
    }
  }, [search])

  function renderFarmers() {
    return farmers?.map((farmer, index) => {
      return <div key={farmer.id} style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
        <SelectedContent as={Link} to={RouteTypes.DAIRY_FACTORY_FARMERS_EDIT.replace(':id', farmer['id'])}>
          <div style={{ display: 'flex' }}>
            <div
              className='title'
            >{`${index + 1}. ${farmer['companyName']}`}
            </div>
          </div>
        </SelectedContent>
        <Icon
          name='trash'
          onClick={() => remove(index)}
          color='red'
          style={{ cursor: 'pointer' }}
        />
      </div>
    })
  }

  return <Dialog
    isDialogOpen={isDialogOpen}
    noScrollingContent={false}
    textHeader={t('Selected farmers')}
    textClose={t('Close')}
    textContent={<div>
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('Search farmers')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
      <SelectedWrapper>
        {renderFarmers()}
      </SelectedWrapper>
    </div>}
    handleClose={() => handleClose()}
  />
}
export default ShowMoreDialog